import React from "react";
import { useSelector } from "react-redux";
import ShipmentDetails from "./reviewShipment/shipmentDetails";
import DeviceDetails from "./reviewShipment/deviceDetails";
import BLEDetails from "./reviewShipment/bleDetails";
import AdditionalDetails from "./reviewShipment/additionalDetails";

function ShipmentCloneStep3() {
  const { editField,ble } = useSelector((state) => ({
    editField: state.shipment.ui.editShipment.editField,
    ble:state.shipment.ui.editShipment?.ble,
  }));
  return (
    <>
      <div className="py-1">
        <div
          className="font-face-vzw"
          style={{
            fontWeight: 700,
            fontSize: "20px",
          }}
        >
          Review Shipment
        </div>
      </div>
      <div className="py-1">
        <ShipmentDetails/>
      </div>
      <div className="py-1">
        <DeviceDetails/>
      </div>
      {editField?.isBLEEnabled?.value === "yes"  && ble?.length > 0 ?
      <div className="py-1">
        <BLEDetails/>
      </div>:""}
      <div className="py-1">
        <AdditionalDetails/>
      </div>
    </>
  );
}

export default ShipmentCloneStep3;
